<template>
  <div class="detail">
    <Header :title="title"></Header>
    <div class="Ques">
      <Item :newsList="newsList"
            v-if="show"
            :eps_lines='true'
            :showText="false">
        <div class="top_right_icon"
             slot="right-icon">
          <span class="icon_span collect"
                @click="clickCollect(newsList[0])"
                :class="newsList[0].is_collection==1?'is_collection':''"> <i></i>
          </span>
          <span class="icon_span number"
                @click="clickLike(newsList[0])"
                :class="newsList[0].is_like==1?'is_like':''"><i></i>{{newsList[0].like_number}}</span>
          <span v-if="newsList[0].del_flag==0"
                class="icon_span delete"
                @click="del_ask(newsList[0])"><i></i></span>
        </div>
        <div slot="images"
             class="answer_img">
          <preview v-if="newsList[0].images!==''"
                   oneLine
                   :imgList="newsList[0].images.split(',')"></preview>
        </div>
      </Item>
    </div>
    <div class="lines"> </div>
    <div class="answer">
      <p class="answer_title">全部回答</p>
      <Empty class="emptyImg"
             v-if="!allAnswer.length"
             :empty_type="{ name: '请耐心等待老师的回答哦', img:emptyImg}"></Empty>
      <AnswerItem v-else
                  :tea_answer="item"
                  class="answerItem"
                  v-for="(item,index) in allAnswer"
                  @ask_more="ask_more"
                  :key="index"></AnswerItem>
    </div>
    <van-popup v-model="showAskMore"
               position="bottom">
      <div class="input_keyboard">
        <input type="text"
               ref="inputs"
               v-model="askMoreContent"
               placeholder="请输入追问内容">
        <span @click="send_moreAsk">发送</span>
      </div>
    </van-popup>

  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import Item from "@/components/que_answers/QueItem";
import AnswerItem from '@/components/que_answers/AnswerItem';
import emptyImg from '../../assets/images/answer_empty.png';
import preview from '@/components/que_answers/Preview'
export default {
  name: "Detail",
  components: {
    Header,
    Item,
    Empty,
    AnswerItem, preview
  },
  data () {
    return {
      title: {
        name: "问题详情"
      },
      show: false,
      course_type: 0,
      attrclassify: [], // 资讯类别
      newsList: [], // 资讯列表
      params: {
        classify_id: ""
      },
      vipCourseCount: "",
      course_types: [],
      id: '',
      allAnswer: [],
      showAskMore: false,
      askMoreContent: '',
      ask_more_id: '',
      emptyImg: emptyImg
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getAskDetail(this.id);
    this.getAnswerList(this.id);
  },
  methods: {
    getAskDetail (id) {//获取问题信息
      this.$http.get(`/api/app/ask/jaskDetail`, { id: id }).then(res => {
        this.newsList.push(res);
        if (this.newsList[0].id) {
          let _this = this;
          setTimeout(function () {
            _this.show = true;
          }, 200)
        }
      });
    },
    getAnswerList (id) {//获取回答列表
      this.$http.get(`/api/app/ask/jaskDetailList`, { id: id, limit: 10, childLimit: 6 }).then(res => {
        this.allAnswer = res.list;
      });
    },
    clickLike (item) {
      let params = { ask_id: item.id, comment_id: 0, user_type: 1 }
      this.$pub.clickLike(params).then((res) => {
        if (item.is_like == 0) {
          item.is_like = 1;
          item.like_number++;
        } else {
          item.is_like = 0;
          item.like_number--;
        }
      });
    },
    clickCollect (item) {
      let params = { ask_id: item.id }
      this.$http.post(`/api/app/ask/clickCollection`, params).then(res => {
        if (item.is_collection == 0) {
          item.is_collection = 1;
        } else {
          item.is_collection = 0;
        }
      });
    },
    del_ask (item) {
      this.$dialog.confirm({
        title: "提示",
        message: "确认删除问题吗？"
      }).then(() => {
        this.$http.delete('/api/app/ask/delMyAsk', { id: item.id }).then(res => {
          this.$router.go(-1);
        })
      }).catch(() => { });
    },
    ask_more (item) {
      this.showAskMore = true;
      this.$nextTick((x) => {
        this.$refs.inputs.focus();
        this.ask_more_id = item.id;
      })
    },
    send_moreAsk () {
      if (this.askMoreContent) {
        let params = { parent_id: this.ask_more_id, content: this.askMoreContent }
        this.$http.post(`/api/app/ask/jaskQuestioning`, params).then(res => {
          this.getAnswerList(this.id);
          this.showAskMore = false;
          this.$toast('追问内容已发送');
          this.askMoreContent = '';
        });
      } else {
        this.$toast('请输入追问内容');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.detail {
  @extend %default-bg;
  background: #fff;
  .Ques {
    // height: 560px;
    background: #fff;
    padding-bottom: 20px;
    border-top: 1px solid #f6f6f6;
    overflow: hidden;
    .top_right_icon {
      float: right;
      margin-top: -14px;
      .icon_span {
        font-size: 22px;
        color: #999;
        line-height: 26px;
        margin-left: 20px;
        display: inline-block;
        i {
          display: inline-block;
          width: 28px;
          height: 21px;
        }
      }
      .collect {
        i {
          padding: 0 0 0 34px;
          background: url("~@/assets/images/collect@2x.png") left center
            no-repeat;
          background-size: 24px 22px;
          vertical-align: middle;
        }
      }
      .number {
        i {
          background: url("~@/assets/images/zan@2x.png") left center no-repeat;
          background-size: 21px 21px;
          vertical-align: middle;
        }
      }
      .delete {
        margin-left: 50px;
        i {
          background: url("~@/assets/images/delete-history.png") no-repeat;
          background-size: 21px 21px;
          vertical-align: middle;
        }
      }
    }
  }
  .lines {
    height: 30px;
    background-color: #f6f6f6;
  }
  .answer {
    .answer_title {
      line-height: 80px;
      font-size: 24px;
      color: #333333;
      height: 80px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 29px;
    }
    .emptyImg {
      background: #fff;
      padding: 100px 0;
      /deep/ img {
        width: 128px;
        height: 128px;
      }
    }
    .answerItem {
      margin-top: 30px;
    }
  }
  .answer_img {
    padding: 20px 0 20px 64px;
    // /deep/ {
    //   .img_item {
    //     height: 160px;
    //     width: 160px;
    //     border-radius: 5px;
    //   }
    // }
    // /deep/ .img_item:nth-child(3n-1) {
    //   margin: 0 50px;
    //   border: 1px solid red;
    // }
  }
  .input_keyboard {
    height: 120px;
    background-color: #fff;
    font-size: 30px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #333333;
    padding: 0 20px;
    input {
      width: 526px;
      height: 78px;
      background-color: #f7f7f7;
      border: none;
      outline: none;
      border-radius: 50px;
      padding: 0 33px;
    }
  }
}
</style>
